<template>
  <div class="form-view">
    <div class="content-list-view">
      <!-- 研发创新 -->
      <el-form
        :model="YFCXForm"
        :rules="YFCXRules"
        class="login-form"
        ref="YFCXForm"
        label-width="184px"
        :disabled="editState"
      >
        <el-form-item label="有无技术转移转化:">
          <el-radio v-model="YFCXForm.ywjszyzh" label="1">是</el-radio>
          <el-radio v-model="YFCXForm.ywjszyzh" label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="有无自主研发的新产品:">
          <el-radio v-model="YFCXForm.ywzzyfdxcp" label="1">是</el-radio>
          <el-radio v-model="YFCXForm.ywzzyfdxcp" label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="有无国际合作和产学研:">
          <el-radio v-model="YFCXForm.ywgjhzhcxy" label="1">是</el-radio>
          <el-radio v-model="YFCXForm.ywgjhzhcxy" label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="是否有研发人员:">
          <el-radio-group v-model="YFCXForm.sfyyfry" @change="sfyyfryChange">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="YFCXForm.sfyyfry == 1"
          label="研发人员:"
          prop="yfry"
        >
          <el-select
            style="width: 240px"
            v-model="YFCXForm.yfry"
            placeholder="请选择研发人员"
          >
            <el-option
              v-for="item in yfryList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="YFCXForm.sfyyfry == 1"
          label="研发人员数量变动:"
          prop="yfryslbd"
        >
          <el-select
            style="width: 240px"
            v-model="YFCXForm.yfryslbd"
            placeholder="请选择研发人员数量变动"
          >
            <el-option
              v-for="item in yfryslbdList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="control-view">
      <el-button
        type="primary"
        style="margin-top: 10px; padding: 10px 27px"
        @click="editForm"
        v-if="editState"
      >
        编辑
      </el-button>
      <el-button
        type="primary"
        style="margin-top: 10px; padding: 10px 27px"
        v-if="!editState"
        @click="saveInfo"
      >
        保存
      </el-button>
    </div>
  </div>
</template>

<script>
import { getRegisterUserEdit, getByToken2 } from "@/api/app";
import YFCX from "@/views/register/modules/YFCX";
export default {
  mixins: [YFCX],
  data() {
    return {
      editState: true
    };
  },
  beforeMount() {
    this.getByToken2();
  },
  methods: {
    editForm() {
      this.editState = false;
    },
    async getByToken2() {
      let { data } = await getByToken2();
      let params = {};
      for (const key in this.YFCXForm) {
        if (data[key]) {
          params[key] = data[key];
        }
      }
      this.YFCXForm = Object.assign({}, this.YFCXForm, params);
    },
    /**提交 */
    saveInfo() {
      this.$refs["YFCXForm"].validate(async valid => {
        if (valid) {
          this.loading = true;
          let params = Object.assign({}, this.YFCXForm);
          getRegisterUserEdit(params)
            .then(res => {
              if (res.data) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.editState = true;
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.control-view {
  padding-left: 320px;
  & .el-button {
    background: rgba(41, 99, 204, 1);
    border-color: rgba(41, 99, 204, 1);
  }
}
</style>
